<template>
  <main class="main main--has-floating-buttons">
    <template v-if="ageCategory !== null">
      <portal to="headerTitle">
        {{ ageCategory.name[hotelSettings.details.primaryLanguage] }}
      </portal>
      <tabable-card id="primarylanguage" cols="12 6@desktop">
        <tabable-card-content :title="$t(`lang.${hotelSettings.details.primaryLanguage}`)">
          <hm-card-inner>
            <hm-input v-model="ageCategory.name[hotelSettings.details.primaryLanguage]"
                      :lazy="true"
                      :disabled="ageCategory.deleted"
                      :label="$t('admin.pageAgeCategory.title')"
                      validate="required"
                      name="title"
                      cols="12" />
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>
      <tabable-card id="languages" cols="12 6@desktop">
        <tabable-card-content v-for="lang in hotelSettings.details.additionalLanguages" :title="$t(`lang.${lang}`)" :key="lang">
          <hm-card-inner>
            <hm-input v-model="ageCategory.name[lang]"
                      :lazy="true"
                      :disabled="ageCategory.deleted"
                      :label="$t('admin.pageAgeCategory.title')"
                      name="title"
                      cols="12" />
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>

      <card v-if="ageCategory.ageQualifier !== 'Adult'" :title="$t('admin.pageAgeCategories.card.general')" cols="12">
        <hm-input-number v-model="ageCategory.ageFrom"
                         :disabled="ageCategory.deleted"
                         :label="$t('admin.pageAgeCategory.ageFrom')"
                         name="ageFrom"
                         validate="required"
                         cols="12 4@tablet 3@desktop" />
        <hm-input-number v-model="ageCategory.ageUntil"
                         :disabled="ageCategory.deleted"
                         :label="$t('admin.pageAgeCategory.ageUntil')"
                         name="ageUntil"
                         validate="required"
                         cols="12 4@tablet 3@desktop" />
        <hm-input-select v-model="ageCategory.ageQualifier"
                         :disabled="ageCategory.deleted"
                         :label="$t('admin.pageAgeCategory.ageQualifier')"
                         name="ageQualifier"
                         cols="12 4@tablet 3@desktop">
          <option v-for="it in enums['AgeQualifyingCode']" v-if="it !== 'Adult'" :value="it" v-html="$t(`AgeQualifyingCode.${it}`)"></option>
        </hm-input-select>
      </card>

      <hm-floating-buttons id="actions" ref="floatingButtons">
        <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && !ageCategory.deleted && ageCategory.ageQualifier !== 'Adult'"
                            :label="$t('admin.pageAgeCategories.actions.deleteAgeCategory')"
                            icon="delete"
                            color="error"
                            @click="deleteAgeCategory(false)" />
      </hm-floating-buttons>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmFloatingButton from '../../lib/inputs/HmFloatingButton';

export default {
  name: 'PageAgeCategory',
  components: { HmFloatingButton },
  autosave: [
    {
      name: 'ageCategory',
      variable: 'ageCategory',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        if (this.ageCategory.deleted === true) return;

        const toSave = cloneDeep(this.ageCategory);

        this.axios.put(this.serviceUrls.ageCategory.get(this, this.ageCategoryId), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      ageCategory: null,
      ageCategoryId: this.$route.params.ageCategoryId,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.ageCategory.get(this, this.ageCategoryId))
        .then((response) => {
          if (isNil(this.ageCategory)) {
            this.ageCategory = response.data.data;
          }
        });
    },
    deleteAgeCategory(confirmed = false) {
      if (confirmed === true) {
        this.axios.delete(this.serviceUrls.ageCategory.get(this, this.ageCategoryId))
          .then((response) => {
            this.ageCategory = response.data.data;
            this.showSuccessMessage();
            this.$serviceBus.$emit('hotelSettings.update');
            this.$serviceBus.$emit('ageCategory.list');
            this.$router.push({
              name: 'ageCategories',
            });
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.pageAgeCategories.confirmDeleteAgeCategory'),
          (doNotShowAgain) => {
            this.deleteAgeCategory(true);
          },
        );
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageAgeCategory.vue